// otaChannel.js — Capgo OTA channel control. INTERNAL / STAFF USE ONLY.
//
// Every caller MUST be rendered behind the AdminOnly staff-role guard (see the
// /admin/ota route in App.js). Switching a device to the 'staging' channel
// exposes it to merged-but-unpromoted bundles that have NOT cleared the
// production gates (legal-review attestation + isDraftVersion hard-block +
// second-person Environment approval). A real borrower must never be able to
// reach this — that is why it lives only on an admin-authenticated surface, not
// behind an obscure route.
//
// Device-local: setChannel only affects THIS device's update feed. It does not
// change what any other user receives. No-op / throws off the native app.
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

export const OTA_CHANNELS = { STAGING: 'staging', PRODUCTION: 'production' };

export function isNativeOta() {
  return Capacitor.isNativePlatform();
}

export async function getCurrentChannel() {
  if (!isNativeOta()) return null;
  const res = await CapacitorUpdater.getChannel();
  return res?.channel ?? null;
}

async function setChannel(channel) {
  if (!isNativeOta()) {
    throw new Error('OTA channel switching is only available in the native app.');
  }
  await CapacitorUpdater.setChannel({ channel });
  return getCurrentChannel();
}

export const switchToStaging = () => setChannel(OTA_CHANNELS.STAGING);
export const resetToProduction = () => setChannel(OTA_CHANNELS.PRODUCTION);
